import React, { ReactNode, useContext, useMemo, useState } from 'react';

import {
  initialPositionContext,
  NavigationContext,
  NavigationContextType,
  TrackingPositionTypes,
} from './NavigationContext';

// Context provider component
export const NavigationProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [positions, setPositions] = useState<TrackingPositionTypes[]>(
    initialPositionContext
  );

  const setPosition = (index: number, position: number) => {
    setPositions((prevPositions) =>
      prevPositions.map((item, i) => (i === index ? { position } : item))
    );
  };

  // Memoize the context value to avoid unnecessary renders
  const contextValue = useMemo(() => ({ positions, setPosition }), [positions]);

  return (
    <NavigationContext.Provider value={contextValue}>
      {children}
    </NavigationContext.Provider>
  );
};

// Custom hook for using the navigation context
export const useNavigation = (): NavigationContextType => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
};
